module.exports = __webpack_public_path__ + "static/razitko-6b5a9100564e424050933967be2dc686.jpeg";